import { render, staticRenderFns } from "./DepartmentEdit.vue?vue&type=template&id=6bd992de"
import script from "./DepartmentEdit.js?vue&type=script&lang=js&external"
export * from "./DepartmentEdit.js?vue&type=script&lang=js&external"
import style0 from "./DepartmentEdit.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports